var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5A.75.75 0 1 1 9 3a.75.75 0 0 1 0 1.5zM9 9.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM9 15a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.75v.007M9 9v.007m0 5.243v.007M9 4.5A.75.75 0 1 1 9 3a.75.75 0 0 1 0 1.5zm0 5.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM9 15a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z",
    stroke: "#4318ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.3337e33aeee33ac0f6be30386948c87a.svg";
export { ForwardRef as ReactComponent };